import React from "react";

const FAQ = () => {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      {/* Título */}
      <h2 className="text-3xl font-bold text-gray-900 mb-4">
        Frequently asked questions
      </h2>

      {/* Subtítulo */}
      <p className="text-gray-500 mb-8">
        Can’t find the answer you’re looking for? Reach out to our
        <a href="#" className="text-blue-600 font-semibold ml-1">
          customer support
        </a>
        team.
      </p>

      {/* Preguntas */}
      <div className="grid gap-8">
        {/* Pregunta 1 */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-2">
            How do you make holy water?
          </h3>
          <p className="text-gray-500">
            You boil the hell out of it. Lorem ipsum dolor sit amet consectetur
            adipisicing elit. Quas cupiditate laboriosam fugiat.
          </p>
        </div>

        {/* Pregunta 2 */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-2">
            What’s the best thing about Switzerland?
          </h3>
          <p className="text-gray-500">
            I don’t know, but the flag is a big plus. Lorem ipsum dolor sit amet
            consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.
          </p>
        </div>

        {/* Pregunta 3 */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-2">
            What do you call someone with no body and no nose?
          </h3>
          <p className="text-gray-500">
            Nobody knows. Lorem ipsum dolor sit amet consectetur adipisicing
            elit. Quas cupiditate laboriosam fugiat.
          </p>
        </div>

        {/* Pregunta 4 */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-2">
            Why do you never see elephants hiding in trees?
          </h3>
          <p className="text-gray-500">
            Because they’re so good at it. Lorem ipsum dolor sit amet
            consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
